var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5172C3.13827 19.7949 5.92227 19.0639 8.44264 17.2359C5.81791 17.0146 4.0665 15.7328 3.08266 13.3627C3.95802 13.4668 4.7764 13.482 5.64971 13.254C4.28071 12.9365 3.19457 12.291 2.35559 11.2803C1.51112 10.2629 1.09438 9.09778 1.09163 7.74971C1.89216 8.13875 2.70436 8.39458 3.59483 8.4138C1.06486 6.3665 0.486771 3.91823 1.87088 1.02855C2.01711 1.07959 2.06174 1.17304 2.12559 1.24462C4.35417 3.75718 7.11757 5.45453 10.4289 6.31613C11.4621 6.58522 12.5174 6.72904 13.5829 6.80923C13.7518 6.82183 13.7697 6.78471 13.7449 6.62631C13.3818 4.31656 14.1232 2.42302 16.0779 1.01795C18.1945 -0.50311 21.385 -0.295663 23.2813 1.47924C23.5051 1.68867 23.6911 1.74633 23.9925 1.66614C24.5459 1.519 25.0958 1.3659 25.6307 1.16376C26.1641 0.962275 26.6763 0.716387 27.2317 0.404885C26.7745 1.72645 25.9643 2.69741 24.7484 3.45098C25.906 3.33831 26.9365 3.02482 28.0007 2.61257C27.2585 3.67035 26.4168 4.55184 25.4055 5.27492C25.1961 5.42471 25.1384 5.57714 25.1453 5.82303C25.2126 8.38663 24.631 10.819 23.4838 13.1241C22.1114 15.8806 20.1135 18.1095 17.4112 19.7286C15.7202 20.742 13.8857 21.4008 11.9276 21.7328C8.92803 22.2412 5.98544 22.0357 3.11767 21.025C2.04114 20.6459 1.0168 20.1581 0.00137312 19.5179L0 19.5172Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9dc7f61e8af065680e8cfeb4c310863.svg";
export { ForwardRef as ReactComponent };